/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_Bookings_Match_FiltersInputs */

const en_admin_dashboard_no_bookings_match_filters = /** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No bookings match the selected filters`)
};

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const de_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const es_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const fr_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const it_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const pt_br2_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const pl_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const hu_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/** @type {(inputs: Admin_Dashboard_No_Bookings_Match_FiltersInputs) => LocalizedString} */
const ro_admin_dashboard_no_bookings_match_filters = en_admin_dashboard_no_bookings_match_filters;

/**
* | output |
* | --- |
* | "No bookings match the selected filters" |
*
* @param {Admin_Dashboard_No_Bookings_Match_FiltersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_bookings_match_filters = /** @type {((inputs?: Admin_Dashboard_No_Bookings_Match_FiltersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_Bookings_Match_FiltersInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "de") return de_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "es") return es_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "it") return it_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_bookings_match_filters(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_bookings_match_filters(inputs)
	return ro_admin_dashboard_no_bookings_match_filters(inputs)
});
export { admin_dashboard_no_bookings_match_filters as "admin.dashboard.no_bookings_match_filters" }